export enum DialogTypeEnum {
    Dispense,
    Receive,
    RecordLostOrStolen,
    RecordDamagedOrExpired,
    RecordSaleToProvider,
    DispenseInAuditAdjustment,
    ReceiveInAuditAdjustment,
    OtherActionsInAuditAdjustment
}

export function getDialogTypeAddedQtySign(type: DialogTypeEnum): number {
   if (type === DialogTypeEnum.Receive || type === DialogTypeEnum.ReceiveInAuditAdjustment)
    return 1;
   else return -1;
}